module.exports = __webpack_public_path__ + "img/vuleka-logo.95edee2b.png";